import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import React, { Suspense, useState } from 'react'
import toast from 'react-hot-toast'
import { apiService } from '../../api/axiosClient'
import ConfirmDialog from '../../utils/dialog'

const CategoryCard = React.lazy(() => import('./CategoryCard'));

const CategoryWrapper = ({ items, setItems }) => {
    const [open, setOpen] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null)

    const handleConfirm = () => {
        setOpen(false);
        removeCard(deleteItem)
    };

    const handleClose = () => {
        setOpen(false);
    };

    const removeCard = async (item) => {
        try {
            await apiService.delete(`/maincategory/${item.id}`);
            toast.success('Key Product가 삭제되었습니다.');
            setItems((items) => items.filter((k) => k.id !== item.id));
            setDeleteItem(null);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Box>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {items.map((item, index) => (
                        <Grid item xs={3} sm={3} md={3} key={index}>
                            <Suspense fallback={<div>Loading...</div>}>
                                <CategoryCard item={item} setOpen={setOpen} setDeleteItem={setDeleteItem} />
                            </Suspense>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <ConfirmDialog
                open={open}
                title={'Key Product 삭제'}
                content={`Key Product ${deleteItem?.title} 를 삭제하시겠습니까?`}
                handleClose={handleClose}
                handleConfirm={handleConfirm}
            />
        </Box>
    )
}

export default CategoryWrapper